module.exports = __webpack_public_path__ + "img/tampa-bay.83e6dc0c.svg";